import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { ForgeMineContent } from "../forgeContent.js";

/**
 * The creator's own boxes, showroom layout: the heading, the earnings band, then a row per box.
 * One column on every width, like 13 · Exchange's checkout rows.
 */
export function ForgeMineShowroomLayout({ sections }: PageLayoutProps<ForgeMineContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8">
      {sections.heading}
      {sections.earnings}
      {sections.boxes}
    </Section>
  );
}
